import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import siteConfig from "../config/siteConfig";

const routeTitles = {
  "/": "Everyday knitwear selected in Hong Kong",
  "/shop": "Shop natural knitwear",
  "/about": "Our story",
  "/contact": "Customer care",
  "/shipping": "Shipping information",
  "/returns": "Returns policy",
  "/privacy": "Privacy policy",
  "/terms": "Terms and conditions",
  "/cartpage": "Shopping bag",
  "/checkout": "Checkout",
  "/paysuccess": "Order complete",
};

function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const pageTitle = pathname.startsWith("/shopDetails/")
      ? "Product details"
      : routeTitles[pathname];
    document.title = pageTitle
      ? `${pageTitle} — ${siteConfig.brandName}`
      : siteConfig.seo.defaultTitle;

    const description = document.querySelector('meta[name="description"]');
    if (description) {
      description.setAttribute("content", siteConfig.seo.defaultDescription);
    }
  }, [pathname]);

  return null;
}

export default Seo;
